const AiimsFeeHeader = [
    { id: 1, label: "Total BTech course fee (INR)", var: "coursefee" },
    { id: 2, label: "Total BTech hostel fee (INR)", var: "hostelfee" },
];

export default AiimsFeeHeader;
